/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ site: NonNullable<unknown> }} Body_Measures_How_TitleInputs */

const en_us2_body_measures_how_title = /** @type {(inputs: Body_Measures_How_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`How to measure · ${i?.site}`)
};

const pt_br2_body_measures_how_title = /** @type {(inputs: Body_Measures_How_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Como medir · ${i?.site}`)
};

const es_419_body_measures_how_title = /** @type {(inputs: Body_Measures_How_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cómo medir · ${i?.site}`)
};

const pt_pt2_body_measures_how_title = /** @type {(inputs: Body_Measures_How_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Como medir · ${i?.site}`)
};

const fr_fr2_body_measures_how_title = /** @type {(inputs: Body_Measures_How_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Comment mesurer · ${i?.site}`)
};

const de_de2_body_measures_how_title = /** @type {(inputs: Body_Measures_How_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`So misst du · ${i?.site}`)
};

const it_it2_body_measures_how_title = /** @type {(inputs: Body_Measures_How_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Come misurare · ${i?.site}`)
};

/**
* | output |
* | --- |
* | "How to measure · {site}" |
*
* @param {Body_Measures_How_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_measures_how_title = /** @type {((inputs: Body_Measures_How_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Measures_How_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_measures_how_title(inputs)
	if (locale === "es-419") return es_419_body_measures_how_title(inputs)
	if (locale === "pt-PT") return pt_pt2_body_measures_how_title(inputs)
	if (locale === "fr-FR") return fr_fr2_body_measures_how_title(inputs)
	if (locale === "de-DE") return de_de2_body_measures_how_title(inputs)
	if (locale === "it-IT") return it_it2_body_measures_how_title(inputs)
	return en_us2_body_measures_how_title(inputs)
});
export { body_measures_how_title as "body-measures.how_title" }